module.exports = __webpack_public_path__ + "static/img/pic_pctop@2x.77c6a9dc.png";